import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "작업 건너뛰기",
  "description": "동일한 작업을 두 번 수행하지 마세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "캐싱은 작업 속도를 극적으로 높이지만 npx turbo-ignore를 사용하면 더 빠르게 진행할 수 있습니다. 워크스페이스가 코드 변경의 영향을 받지 않는 경우 작업 실행을 완전히 건너뛸 수 있습니다."
  }, {
    "heading": "",
    "content": "web 애플리케이션(또는 그 패키지 종속성)에 변경 사항이 없을 때 web 워크스페이스의 단위 테스트를 건너뛰고 싶다고 가정해 봅시다. Remote Caching을 이미 사용하고 있다면 캐시 히트를 얻을 가능성이 높지만 CI 컨테이너 프로비저닝, npm 종속성 설치 및 기타 시간이 걸릴 수 있는 작업에 여전히 시간을 소비하게 됩니다."
  }, {
    "heading": "",
    "content": "이상적으로는 그러한 작업이 처음부터 필요한지 빠르게 확인할 수 있습니다."
  }, {
    "heading": "",
    "content": "리포지토리를 체크아웃한 후 다른 작업을 수행하기 전에 몇 초를 들여 web 테스트가 상위 커밋 이후 변경되었는지 확인할 수 있습니다."
  }, {
    "heading": "",
    "content": "이 명령은 다음을 수행합니다:"
  }, {
    "heading": "",
    "content": "web 워크스페이스를 필터링합니다."
  }, {
    "heading": "",
    "content": "상위 커밋과 비교하여 test 작업에 대한 dry 출력을 생성합니다."
  }, {
    "heading": "",
    "content": "출력을 파싱하여 변경된 패키지를 확인합니다."
  }, {
    "heading": "",
    "content": "변경 사항이 감지되면 1 코드로 종료합니다. 그렇지 않으면 0으로 종료합니다."
  }, {
    "heading": "",
    "content": "이 작업에 대해 >>> FULL TURBO 캐시를 히트할 수 있었지만 CI를 실행하는 데 필요한 다른 모든 설정 작업으로 시간을 절약했습니다."
  }, {
    "heading": "turbo-ignore-사용",
    "content": "영향을 받지 않는 작업을 건너뛰려면 먼저 머신에서 Git 기록을 사용할 수 있는지 확인하세요. 그런 다음 npx turbo-ignore를 실행합니다."
  }, {
    "heading": "turbo-ignore-사용",
    "content": "turbo-ignore는 --filter 및 --dry=json 플래그의 조합을 사용하여 상위 커밋에서 현재 커밋까지의 변경 사항을 찾아 영향을 받는 패키지를 식별합니다. 기본적으로 turbo-ignore는 현재 작업 디렉토리의 build 작업에 대한 차이를 찾지만 플래그로 이 동작을 사용자 정의할 수 있습니다."
  }, {
    "heading": "turbo-ignore-사용",
    "content": "다음은 빌드되고 실행될 명령의 예입니다:"
  }, {
    "heading": "turbo-ignore-사용",
    "content": "dry run은 build 작업을 실행하지 않습니다. 대신 코드 변경이 몇 초 안에 빌드(또는 다른 작업)에 영향을 미치는지 패키지를 확인합니다."
  }, {
    "heading": "turbo-ignore-사용",
    "content": "turbo-ignore가 작업을 건너뛸 수 있음을 발견하면 0 코드로 프로세스를 종료합니다. 변경 사항이 발견되면 프로세스는 1로 종료됩니다."
  }, {
    "heading": "turbo-ignore-사용",
    "content": "Vercel에서는 상위 커밋 대신 이전에 배포된 SHA가 사용됩니다."
  }, {
    "heading": "동작-사용자-정의",
    "content": "워크스페이스를 지정하려면 다음과 같이 명령에 추가할 수 있습니다:"
  }, {
    "heading": "동작-사용자-정의",
    "content": "여기서 web은 기본 build 작업을 실행하는 워크스페이스의 이름입니다."
  }, {
    "heading": "동작-사용자-정의",
    "content": "작업을 변경하려면 --task 플래그를 사용하여 turbo-ignore가 호출할 명령의 작업을 지정하세요."
  }, {
    "heading": "vercel에서-turbo-ignore-사용",
    "content": "Vercel에서 npx turbo-ignore를 사용하려면 Ignored Build Step 기능을 사용할 수 있습니다. Vercel은 turbo-ignore를 성공적으로 실행하기 위한 올바른 인수를 자동으로 추론합니다."
  }, {
    "heading": "동작-사용자-정의-1",
    "content": "Vercel이 아닌 경우 --fallback 플래그를 사용하여 비교할 커밋을 지정하세요."
  }, {
    "heading": "동작-사용자-정의-1",
    "content": "Vercel에서는 --fallback 플래그를 지정하여 기본 비교를 사용할 수 없을 때 비교할 git ref를 Vercel에 제공할 수 있습니다. 기본적으로 Vercel은 가장 최근에 배포된 SHA와 비교하므로 이는 브랜치의 첫 번째 커밋에 대한 배포를 피하는 것과 같은 사용 사례에 유용합니다."
  }],
  "headings": [{
    "id": "turbo-ignore-사용",
    "content": "turbo-ignore 사용"
  }, {
    "id": "동작-사용자-정의",
    "content": "동작 사용자 정의"
  }, {
    "id": "vercel에서-turbo-ignore-사용",
    "content": "Vercel에서 turbo-ignore 사용"
  }, {
    "id": "동작-사용자-정의-1",
    "content": "동작 사용자 정의"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#turbo-ignore-사용",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo-ignore"
    }), " 사용"]
  })
}, {
  depth: 2,
  url: "#동작-사용자-정의",
  title: _jsx(_Fragment, {
    children: "동작 사용자 정의"
  })
}, {
  depth: 2,
  url: "#vercel에서-turbo-ignore-사용",
  title: _jsxs(_Fragment, {
    children: ["Vercel에서 ", _jsx("code", {
      children: "turbo-ignore"
    }), " 사용"]
  })
}, {
  depth: 2,
  url: "#동작-사용자-정의-1",
  title: _jsx(_Fragment, {
    children: "동작 사용자 정의"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "캐싱"
      }), "은 작업 속도를 극적으로 높이지만 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "를 사용하면 더 빠르게 진행할 수 있습니다. 워크스페이스가 코드 변경의 영향을 받지 않는 경우 작업 실행을 완전히 건너뛸 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "web"
      }), " 애플리케이션(또는 그 패키지 종속성)에 변경 사항이 없을 때 ", _jsx(_components.code, {
        children: "web"
      }), " 워크스페이스의 단위 테스트를 건너뛰고 싶다고 가정해 봅시다. ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "을 이미 사용하고 있다면 캐시 히트를 얻을 가능성이 높지만 CI 컨테이너 프로비저닝, ", _jsx(_components.code, {
        children: "npm"
      }), " 종속성 설치 및 기타 시간이 걸릴 수 있는 작업에 여전히 시간을 소비하게 됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "이상적으로는 그러한 작업이 처음부터 필요한지 빠르게 확인할 수 있습니다."
    }), "\n", _jsx(_components.hr, {}), "\n", _jsxs(_components.p, {
      children: ["리포지토리를 체크아웃한 후 다른 작업을 수행하기 ", _jsx(_components.strong, {
        children: "전에"
      }), " 몇 초를 들여 ", _jsx(_components.code, {
        children: "web"
      }), " 테스트가 상위 커밋 이후 변경되었는지 확인할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --task=test"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 명령은 다음을 수행합니다:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "web"
        }), " 워크스페이스를 필터링합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["상위 커밋과 비교하여 ", _jsx(_components.code, {
          children: "test"
        }), " 작업에 대한 ", _jsx(_components.code, {
          children: "dry"
        }), " 출력을 생성합니다."]
      }), "\n", _jsx(_components.li, {
        children: "출력을 파싱하여 변경된 패키지를 확인합니다."
      }), "\n", _jsxs(_components.li, {
        children: ["변경 사항이 감지되면 ", _jsx(_components.code, {
          children: "1"
        }), " 코드로 종료합니다. 그렇지 않으면 ", _jsx(_components.code, {
          children: "0"
        }), "으로 종료합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["이 작업에 대해 ", _jsx(_components.code, {
        children: ">>> FULL TURBO"
      }), " 캐시를 히트할 수 있었지만 CI를 실행하는 데 필요한 다른 모든 설정 작업으로 시간을 절약했습니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbo-ignore-사용",
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), " 사용"]
    }), "\n", _jsxs(_components.p, {
      children: ["영향을 받지 않는 작업을 건너뛰려면 먼저 머신에서 Git 기록을 사용할 수 있는지 확인하세요. 그런 다음 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "를 실행합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), "는 ", _jsx(_components.code, {
        children: "--filter"
      }), " 및 ", _jsx(_components.code, {
        children: "--dry=json"
      }), " 플래그의 조합을 사용하여 상위 커밋에서 현재 커밋까지의 변경 사항을 찾아 영향을 받는 패키지를 식별합니다. 기본적으로 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "는 ", _jsx(_components.strong, {
        children: "현재 작업 디렉토리의 build 작업"
      }), "에 대한 차이를 찾지만 ", _jsx(_components.a, {
        href: "#customizing-behavior",
        children: "플래그로 이 동작을 사용자 정의"
      }), "할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "다음은 빌드되고 실행될 명령의 예입니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@example/web...3c8387ffd98b751305fe3f0284befdd00cbd4610"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --dry=json"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["dry run은 build 작업을 ", _jsx(_components.em, {
        children: "실행하지 않습니다"
      }), ". 대신 코드 변경이 몇 초 안에 빌드(또는 다른 작업)에 영향을 미치는지 패키지를 확인합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), "가 작업을 건너뛸 수 있음을 발견하면 ", _jsx(_components.code, {
        children: "0"
      }), " 코드로 프로세스를 종료합니다. 변경 사항이 발견되면 프로세스는 ", _jsx(_components.code, {
        children: "1"
      }), "로 종료됩니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "Vercel에서는 상위 커밋 대신 이전에 배포된 SHA가 사용됩니다."
      })
    }), "\n", _jsx(_components.h2, {
      id: "동작-사용자-정의",
      children: "동작 사용자 정의"
    }), "\n", _jsx(_components.p, {
      children: "워크스페이스를 지정하려면 다음과 같이 명령에 추가할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["여기서 ", _jsx(_components.code, {
        children: "web"
      }), "은 기본 ", _jsx(_components.code, {
        children: "build"
      }), " 작업을 실행하는 워크스페이스의 이름입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["작업을 변경하려면 ", _jsx(_components.code, {
        children: "--task"
      }), " 플래그를 사용하여 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "가 호출할 명령의 작업을 지정하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "vercel에서-turbo-ignore-사용",
      children: ["Vercel에서 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 사용"]
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel에서 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "를 사용하려면 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/projects/overview#ignored-build-step",
        children: "Ignored Build Step"
      }), " 기능을 사용할 수 있습니다. Vercel은 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "를 성공적으로 실행하기 위한 올바른 인수를 자동으로 추론합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "동작-사용자-정의-1",
      children: "동작 사용자 정의"
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel이 아닌 경우 ", _jsx(_components.code, {
        children: "--fallback"
      }), " 플래그를 사용하여 비교할 커밋을 지정하세요."]
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel에서는 ", _jsx(_components.code, {
        children: "--fallback"
      }), " 플래그를 지정하여 기본 비교를 사용할 수 없을 때 비교할 git ref를 Vercel에 제공할 수 있습니다. 기본적으로 Vercel은 가장 최근에 배포된 SHA와 비교하므로 이는 브랜치의 첫 번째 커밋에 대한 배포를 피하는 것과 같은 사용 사례에 유용합니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
